import { Stack, Typography } from "@mui/material";
import React from "react";

import useShopContext from "@hooks/useShopContext";
import { Box } from "@mui/system";

import AnimateWrapper from "@common/animations/AnimateWrapper";
import { hexToRGBWithAlpha } from "@common/utils/colors";
import Element from "./components/Elements";
import ShopReviews from "./components/ShopReviews";
import SocialLinks from "./components/SocialLinks";

const HomePage = () => {
  const { shop } = useShopContext();

  return (
    <Stack
      sx={(theme) => ({
        minHeight: "100vh",
        display: "grid",
        placeItems: "center",
        p: {
          xs: 3,
          md: 4,
        },
        backgroundColor: theme.palette.primary.main,
        backgroundImage: shop?.background_image ? `url(${shop.background_image})` : "none",
        backgroundAttachment: "fixed",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      })}
    >
      <AnimateWrapper
        key="homepage"
        transition={{ duration: 0.5 }}
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
      >
        <Stack
          alignItems="center"
          gap={2}
          sx={(theme) => ({
            borderRadius: 3,
            width: {
              xs: "85vw",
              md: 500,
            },
            px: {
              xs: 3,
              md: 4,
            },
            py: {
              xs: 5,
              md: 6,
            },
            backgroundColor: hexToRGBWithAlpha(
              theme.palette.primary.main,
              shop?.text_background_opacity || 1,
            ),
          })}
        >
          {(shop?.logo || shop?.vendor?.company_photo) && (
            <Box
              component="img"
              src={shop?.logo || shop?.vendor?.company_photo}
              alt="Logo"
              sx={{
                maxWidth: { xs: "30%", md: 135 },
                mb: 2,
              }}
            />
          )}
          <Stack gap={1} alignItems="center">
            <Typography
              variant="h4"
              sx={(theme) => ({
                color: shop?.text_color || theme.palette.primary.contrastText,
              })}
            >
              {shop?.title}
            </Typography>
            <SocialLinks />
            <ShopReviews />
          </Stack>
          <Stack gap={2} sx={{ width: "100%", my: 2 }}>
            {shop?.elements.map((element) => (
              <Element
                key={element.element_id}
                {...element}
                disabled={
                  element.element_type === "Route" && !shop?.is_active && !shop?.use_welcome_page
                }
                hidden={
                  element.element_type === "Route" && !shop?.is_active && shop?.use_welcome_page
                }
              />
            ))}
          </Stack>
        </Stack>
      </AnimateWrapper>
    </Stack>
  );
};

export default HomePage;
